<button class="btn btn-dark btn-wxl" style="padding: 10px 40px; border-radius: 25px;" (click)="onOpen()" [disabled]="!(tickets!.length)">{{model?.subTotal == 0 ? 'Adquirir' :
    'Comprar'}}</button>


<ng-template #purchaseModal let-modal>
    <div class="modal-header">
        <div class="d-flex w-100">
            <div class="cursor-pointer" (click)="modal.dismiss()" style="z-index: 1;">
                <i class="mdi mdi-arrow-left mdi-24px"></i>
            </div>
            <div class="text-center w-100 m-l-10 font-h6" style="margin-left: -24px;">
                Resumen de la orden
            </div>
        </div>
    </div>

    <div class="modal-body">
        <!-- Summary -->
        <div>

            <!-- Imagen de portada -->
            <div class="d-flex-center p-b-20 border-bottom ">
                <div class="picsum-img-wrapper">
                    <img src="{{event.logoUrl}}" class="image-size" onError="this.src='assets/images/noimage.png'">
                </div>
            </div>

            <!-- Tickets -->
            <ng-container *ngFor="let ticket of tickets;let index = index;">
                <div class="border-bottom p-t-10 p-b-10">
                    <div class="ffont-c1 m-l-10">
                        <!--Product Name-->
                        <div class="text-wrap ffont-c1 font-bold">
                            {{ticket.name}}
                            <span *ngIf="ticket.quantityOfPlaces > 0" class="ml-1 text-muted font-14">
                                (<i *ngIf="ticket.quantityOfPlaces == 1" class="mdi mdi-account-multiple"></i>
                                <i *ngIf="ticket.quantityOfPlaces > 1" class="mdi mdi-account-multiple"></i>
                                {{ticket.quantityOfPlaces}})
                            </span>
                        </div>

                        <!-- Price-->
                        <div *ngIf="ticket.priceWithoutPlusWithTax > 0">
                            <div *ngIf="ticket.priceWithoutPlusWithTax > 0" class="font-c2">
                                <span class="text-muted">Costo por entrada: </span>
                                <span *ngIf="ticket.priceWithoutPlusWithTax > 0">{{ticket.quantitySelected}}x ({{ticket.priceWithoutPlusWithTax | currency: ticket?.currencySymbol
                                    : 'symbol': '1.0'}})</span>
                                <span *ngIf="ticket.priceWithoutPlusWithTax <= 0">{{ticket.quantitySelected}}x (Gratis)</span>
                            </div>
                            <div class="font-c2">
                                <span class="text-muted">Costo por experiencia: </span>
                                <span *ngIf="ticket.price > 0">{{ticket.quantitySelected}}x ({{ticket.price | currency: ticket?.currencySymbol : 'symbol': '1.0'}})</span>
                                <span *ngIf="ticket.price <= 0">{{ticket.quantitySelected}}x (Gratis)</span>
                            </div>
                        </div>
                        <div *ngIf="!ticket.priceWithoutPlusWithTax" class="font-c2">
                            <span class="text-muted">Costo por entrada: </span>
                            <span *ngIf="ticket.price > 0">{{ticket.quantitySelected}}x ({{ticket.price | currency: ticket?.currencySymbol : 'symbol': '1.0'}})</span>
                            <span *ngIf="ticket.price <= 0">{{ticket.quantitySelected}}x (Gratis)</span>
                        </div> 
                    </div>
                </div>
            </ng-container>

            <!-- Totals -->
            <div class="border-bottom p-t-10 p-b-10">
                <!-- Subtotal -->
                <div class="d-flex flex-row justify-content-between m-l-10">
                    <div class="">
                        Sub-Total
                    </div>
                    <div class="font-bold">
                        {{model.subTotal | currency: model?.currencySymbol : 'symbol': '1.2'}}
                    </div>
                </div>
                <!-- Subtotal -->
                <div *ngIf="model.commissionCost || model.validationCost" class="d-flex flex-row justify-content-between m-l-10">
                    <div class="">
                        Tarifa de reserva
                    </div>
                    <div class="font-bold">
                        {{(model.commissionCost + model.validationCost) | currency: model?.currencySymbol : 'symbol': '1.2'}}
                    </div>
                </div>
                <!-- All Customer Commission -->
                <div *ngIf="model.allCustomerCommission" class="d-flex flex-row justify-content-between m-l-10">
                    <div class="">
                        Costo por servicio
                        <i class="mdi mdi-information text-primary cursor-pointer ml-2 custom-icon" [ngbPopover]="popContent" container="body"></i>
                        <ng-template #popContent>
                            <b>Tarifa porcentual</b><br>
                            <ul>
                                <li>Costos gubernamentales</li>
                                <li>Costos marcas de tarjetas (Visa, Mastercard, Amex)</li>
                                <li>Costos de proveedor de procesamiento de pagos</li>
                                <li>Costos Bancarios</li>
                            </ul>
                            <!-- Se muestra aparte 
                            <b>Costo por transacción 350</b><br>
                            -->
                            <b>Comisión Givi</b>
                        </ng-template>
                    </div>
                    <div class="font-bold">
                        {{(model.allCustomerCommission) | currency: model?.currencySymbol : 'symbol': '1.2'}}
                    </div>
                </div>
                
                <div class="d-flex flex-row justify-content-between m-l-10">
                    <div class="">
                        Total
                    </div>
                    <div class="font-bold">
                        {{model.total | currency: model?.currencySymbol : 'symbol': '1.2'}}
                    </div>
                </div>
            </div>

            <div class="bg-dark m-t-20 m-b-20 d-flex justify-content-center align-items-center" style="height: 40px; border-radius: 5px;">
                <div class="text-center w-100 font-b2 text-white" style="margin-right: -24px;">
                    Métodos de pago
                </div>
            </div>

            <!-- Aplicar Puntos,  1 == pointsAccordion-->
            <!-- <div class="p-b-10" (click)="onToggleAccordion(1)">
                
                <div class="d-flex flex-row justify-content-between bg-light rounded p-3">
                    <div class="text-left">
                        <img class="m-5-5 p-r-10" src="assets/images/givi-cash-logo.png" width="36">

                        <span class="font-bold font-12">
                            Aplicar puntos a mi compra
                        </span>
                    </div>

                    <span class="font-bold font-18" [ngStyle]="{'transform': pointsAccordion ? 'rotate(90deg)' : 'none'}">
                        >
                    </span>
                </div>
            </div>
             Abre acordeon --
            <div *ngIf="pointsAccordion" class="m-t-20">
                <div *ngIf="user.availablePoints" class="m-t-20">
                    <app-purchase-with-points-modal [user]="user" [model]="model" (sendPointsSelected)="onReceivePointsSelected($event)"
                        [pointsSelected]="model.points"></app-purchase-with-points-modal>
                </div>
                <div *ngIf="!user.availablePoints" class="m-b-20">
                    <div class="mx-auto text-center">
                        <div class="font-bold">
                            <div class="font-12 font-bold">
                                "No tenés puntos disponibles."
                                <br>
                                <a href="javascript:void(0)" (click)="onShowGetPoints()">Ver cómo puedo conseguir puntos</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Tarjeta -->
            <div *ngIf="currentMethod" class="border-bottom p-20 cursor-pointer" (click)="onOpenMethods(paymentMethodModal, darkMode)">

                <div class="d-flex flex-row justify-content-between">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5" src="{{currentMethod.logoURL}}" width="36">

                        <span class="font-bold font-10">
                            {{currentMethod?.name ? currentMethod?.name : '**** **** ****' }} {{currentMethod.masked}}
                        </span>
                    </div>

                    <span class="font-bold font-18">
                        >
                    </span>
                </div>
            </div>


            <!-- Agregar Tarjeta -->
            <div *ngIf="!currentMethod" class="p-b-10 comment-row" (click)="onOpenCreateCard(addPaymentMethodModal, darkMode)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-20 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>

            <!-- Factura electrónica -->
            <!-- <div *ngIf="user.billingInfo?.isValid" class="border-bottom p-20 cursor-pointer">

                <div class="form-group">
                    <input id="checkbox-billing" type="checkbox" [(ngModel)]="requireInvoice">
                    <label for="checkbox-billing" class="m-l-10 font-b2"> Recibir factura electrónica</label>
                </div>
            </div> -->

            <!-- button submit -->
            <div class="p-20">
                <div class="d-flex-center">
                    <button [disabled]="invalidCard" class="btn btn-dark btn-wxl" style="padding: 10px 40px; border-radius: 25px;" (click)="onPay()">{{model.subTotal == 0 ? 'Adquirir' : 'Pagar'}}</button>
                </div>
    
                <div *ngIf="requireVisa && invalidCard" class="d-flex-center p-t-20 font-12 text-danger">
                    * Válido solo para tarjetahabientes Visa
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #freePurchaseModal let-modal>
    <div class="modal-header">
        <div class="d-flex w-100">
            <div class="cursor-pointer" (click)="modal.dismiss()" style="z-index: 1;">
                <i class="mdi mdi-arrow-left mdi-24px"></i>
            </div>
            <div class="text-center w-100 m-l-10 font-h6" style="margin-left: -24px;">
                Resumen de la orden
            </div>
        </div>
    </div>

    <div class="modal-body">
        <!-- Summary -->
        <div>

            <!-- Imagen de portada -->
            <div class="d-flex-center p-b-20 border-bottom ">
                <div class="picsum-img-wrapper">
                    <img src="{{event.logoUrl}}" class="image-size" onError="this.src='assets/images/noimage.png'">
                </div>
            </div>

            <!-- Tickets -->
            <ng-container *ngFor="let ticket of tickets;let index = index;">
                <div class="border-bottom p-t-10 p-b-10">
                    <div class="ffont-c1 m-l-10">
                        <!--Product Name-->
                        <div class="text-wrap ffont-c1 font-bold">
                            {{ticket.name}}
                            <span *ngIf="ticket.quantityOfPlaces > 0" class="ml-1 text-muted font-14">
                                (<i *ngIf="ticket.quantityOfPlaces == 1" class="mdi mdi-account-multiple"></i>
                                <i *ngIf="ticket.quantityOfPlaces > 1" class="mdi mdi-account-multiple"></i>
                                {{ticket.quantityOfPlaces}})
                            </span>
                        </div>

                        <!-- Price-->
                        <div *ngIf="ticket.priceWithoutPlusWithTax > 0">
                            <div *ngIf="ticket.priceWithoutPlusWithTax > 0" class="font-c2">
                                <span class="text-muted">Costo por entrada: </span>
                                <span>{{ticket.quantitySelected}}x (Gratis)</span>
                            </div>
                            <div class="font-c2">
                                <span class="text-muted">Costo por experiencia: </span>
                                <span>{{ticket.quantitySelected}}x (Gratis)</span>
                            </div>
                        </div>
                        <div *ngIf="!ticket.priceWithoutPlusWithTax" class="font-c2">
                            <span class="text-muted">Costo por entrada: </span>
                            <span>{{ticket.quantitySelected}}x (Gratis)</span>
                        </div>

                        <!-- Total -->
                        <div class="font-c2">
                            <span class="text-muted">Costo total: </span>
                            <span class="font-bold" *ngIf="ticket.priceTotal > 0">{{ticket.priceTotal | currency: ticket?.currencySymbol : 'symbol': '1.0'}}</span>
                            <span class="font-bold" *ngIf="ticket.priceTotal <= 0">Gratis</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Totals -->
            <div class="border-bottom p-t-10 p-b-10">
                <!-- Total -->
                <div class="d-flex flex-row justify-content-between m-l-10">
                    <div class="">
                        Total
                    </div>
                    <div class="font-bold" *ngIf="model.total > 0">
                        {{model.total | currency: modal?.currencySymbol : 'symbol': '1.2'}}
                    </div>
                    <div class="font-bold" *ngIf="model.total <= 0">
                        Gratis
                    </div>
                </div>
            </div>

            <!-- button submit -->
            <div class="d-flex-center p-20">
                <button [disabled]="!(model && !(model.subTotal > 0 && currentMethod))" class="btn btn-dark btn-wxl" style="padding: 10px 40px; border-radius: 25px;" (click)="onPay()">{{model?.subTotal == 0 ?
                    'Adquirir' : 'Comprar'}}</button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Opciones de pago -->
<ng-template #paymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-multiple mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Opciones de pago
            </div>
        </div>

        <!-- Tarjeta -->
        <div *ngFor="let sourceItem of methods">
            <div class="border-bottom p-20 cursor-pointer" (click)="onSelectMethod(sourceItem, modal)">

                <div class="d-flex flex-row justify-content-between">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5" src="{{sourceItem.logoURL}}" width="36">

                        <span class="font-bold font-10">
                            {{sourceItem?.name ? sourceItem?.name : '**** **** ****' }} {{sourceItem.masked}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Agregar tarjeta -->
        <div class="p-20">
            <div class="p-b-10 comment-row" (click)="onOpenCreateCard(addPaymentMethodModal, darkMode)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-20 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Agregar nueva tarjeta -->
<ng-template #addPaymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="m-b-20 border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-plus mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Agregar nueva tarjeta
            </div>
        </div>

        <!-- Formulario de tarjeta compartido: decide solo si muestra los campos de
             ONVO o los de Stripe según la pasarela del país -->
        <div class="m-b-20 p-20">
            <app-card-form [country]="country" (cardChange)="onCardChange($event)"></app-card-form>

            <div>
                <img src="assets/images/masterVisaStripe.png" height="28">
            </div>
        </div>

        <div class="d-flex-center">
            <button [disabled]="readonly || !newCard" (click)="onSaveCard(modal)"
                class="btn btn-primary btn-sm m-2">Agregar</button>
        </div>
    </div>
</ng-template>

<app-get-points-modal></app-get-points-modal>

<ng-container *ngIf="assignedSuccess">
    <app-assigned-givi (close)="onCloseSucess()"></app-assigned-givi>
</ng-container>
